import {
  PROSPECT_RECEIVE_NOTIFICATION_GET_ALL,
  PROSPECT_RECEIVE_NOTIFICATION_GET_ALL_SUCCESS,
  PROSPECT_RECEIVE_NOTIFICATION_GET_ALL_ERROR,
  PROSPECT_RECEIVE_NOTIFICATION_GET_BY_ID,
  PROSPECT_RECEIVE_NOTIFICATION_GET_BY_ID_SUCCESS,
  PROSPECT_RECEIVE_NOTIFICATION_GET_BY_ID_ERROR,
  PROSPECT_RECEIVE_NOTIFICATION_ADD_NEW,
  PROSPECT_RECEIVE_NOTIFICATION_ADD_NEW_SUCCESS,
  PROSPECT_RECEIVE_NOTIFICATION_ADD_NEW_ERROR,
  PROSPECT_RECEIVE_NOTIFICATION_EDIT,
  PROSPECT_RECEIVE_NOTIFICATION_EDIT_SUCCESS,
  PROSPECT_RECEIVE_NOTIFICATION_EDIT_ERROR,
  PROSPECT_RECEIVE_NOTIFICATION_DELETE,
  PROSPECT_RECEIVE_NOTIFICATION_DELETE_SUCCESS,
  PROSPECT_RECEIVE_NOTIFICATION_DELETE_ERROR,
} from '../actions';

const initialState = {
  items: [],
  item: null,
  loading: false,
  error: null,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case PROSPECT_RECEIVE_NOTIFICATION_DELETE:
    case PROSPECT_RECEIVE_NOTIFICATION_EDIT:
    case PROSPECT_RECEIVE_NOTIFICATION_ADD_NEW:
    case PROSPECT_RECEIVE_NOTIFICATION_GET_BY_ID:
    case PROSPECT_RECEIVE_NOTIFICATION_GET_ALL:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case PROSPECT_RECEIVE_NOTIFICATION_GET_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
        loading: false,
      };

    case PROSPECT_RECEIVE_NOTIFICATION_GET_ALL_SUCCESS:
      return {
        ...state,
        items: payload,
        loading: false,
      };

    case PROSPECT_RECEIVE_NOTIFICATION_ADD_NEW_SUCCESS:
      return {
        ...state,
        loading: false,
        item: payload,
        items: state.items.concat(payload),
      };

    case PROSPECT_RECEIVE_NOTIFICATION_EDIT_SUCCESS:
      return {
        ...state,
        loading: false,
        items: state.items.map(c => {
          return c.id === payload.id ? payload : c;
        }),
        item: payload,
        error: null,
      };

    case PROSPECT_RECEIVE_NOTIFICATION_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        items: state.items.filter(c => c.id !== payload),
        error: null,
      };

    case PROSPECT_RECEIVE_NOTIFICATION_GET_ALL_ERROR:
    case PROSPECT_RECEIVE_NOTIFICATION_GET_BY_ID_ERROR:
    case PROSPECT_RECEIVE_NOTIFICATION_ADD_NEW_ERROR:
    case PROSPECT_RECEIVE_NOTIFICATION_EDIT_ERROR:
    case PROSPECT_RECEIVE_NOTIFICATION_DELETE_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
};
